import React, { useEffect, useState } from 'react';
import './Home.css';

export default function Home() {
  const [currentDate, setCurrentDate] = useState(new Date());
  const [month, setMonth] = useState('');
  const initialMinutes = 15;
  const [minutes, setMinutes] = useState(initialMinutes);
  const [seconds, setSeconds] = useState(0);

  const [name, setName] = useState("");
  const [number, setNumber] = useState();
  const [email, setEmail] = useState("");
  const [err, setErr] = useState(false);
  const [enquire, setEnquire] = useState(false);

  const submitForm = (e) => {
    e.preventDefault();
    if (name ==="" || email === "" || number === "") {
      setErr(true);
    } else {
      setErr(false);
      setEnquire(false)
      setEmail("")
      setNumber("")
      setName("")
    }
  };

  const buttonClick = () => {
    setEnquire(!enquire);
  };

  useEffect(() => {
    const intervalId = setInterval(() => {
      if (minutes === 0 && seconds === 0) {
        // Reset to 15 minutes and 0 seconds when the timer reaches 0
        setMinutes(initialMinutes);
        setSeconds(0);
        clearInterval(intervalId); // Optional: Stop the interval when the timer reaches 0
      } else if (seconds === 0) {
        // Decrement minutes and reset seconds to 59 when seconds reach 0
        setMinutes((prevMinutes) => prevMinutes - 1);
        setSeconds(59);
      } else {
        // Decrement seconds when they are greater than 0
        setSeconds((prevSeconds) => prevSeconds - 1);
      }
    }, 1000); // Run every 1 second (1000 milliseconds)

    // Cleanup the interval on component unmount
    return () => clearInterval(intervalId);
  }, [minutes, seconds, initialMinutes]); // Re-run the effect whenever minutes, seconds, or initialMinutes change

  



  return (
    <div className='Home'>

{/* logo */}

<div className="logo">
    <img src={require('../Assets/logo.png')} />
</div>

{/* top section */}

<div className="top_section sec">
    <div className="upper_box">
    <h5>4 Hrs (3.5 Hrs + 30 Mins Bonus<br/> Content) Live Online</h5>
    </div>
    <h2>Join and Become Like The Top 1% Successful Business Owners & Entrepreneurs</h2>
    <h4>Before its too late</h4>
</div>


{/* what Happen */}

<div className="what_happen sec">

<div className="left_section">
    <section>
    <div className="profile">
        <img src={require('../Assets/Rajesh Gurusamy profile.png')} width="100%" />
    </div>

    <div className="detail">
        <p className='light_text'>I will be your coach for 4 Hrs (3.5 Hrs + 30 Mins Bonus Content)</p>
        <h3>Rajesh Gurusamy</h3>
        <p  className='light_text'>India’s Leading Business Success Coach</p>
        <hr/>
        <h5>Trained over 216,627 Business Owners in Last 6 Years</h5>
    </div>
    </section>
    <div className="review_bar">
        <div className="stars">
        <i class="fa-solid fa-star"></i>
        <i class="fa-solid fa-star"></i>
        <i class="fa-solid fa-star"></i>
        <i class="fa-solid fa-star"></i>
        <i class="fa-solid fa-star"></i>
        </div>
        <p className='light_text'><span>70,000+</span> People Rated<br/>
My Programs with 4.96 Star</p>
    </div>
</div>

<div className="right_section">
    <section>
        <h2>What Happens When You Join?</h2>
        <hr/>
        <ul>
            <li><img src={require('../Assets/li icon.png')} /> You Unlock Secrets To Create Time & Wealth In Business</li>
            <li><img src={require('../Assets/li icon.png')} /> You Learn Strong Foundational Activities To Win In Your Business</li>
            <li><img src={require('../Assets/li icon.png')} /> Your Business Growth With Increased Revenue & Cashflow</li>
            <li><img src={require('../Assets/li icon.png')} /> More Profit, More Freedom, More Scale Is Guaranteed If You Follow The Exact Steps Covered In The Workshop</li>
        </ul>
    </section>
</div>

</div>


{/* date details */}

<div className="date_detail sec">
    <div className="left_section">
        <section>
            <h3 className='light_text'>STARTS ON {currentDate.getDate()+3}th {month} <br/>
(09:00 AM - 01:00 PM)</h3>
<p>Language - Basic English​</p>
<button onClick={buttonClick} class="register_btn">REGISTER NOW AT ₹99/- ONLY</button>
        </section>
    </div>
    <div className="right_section">
        <h3>Register in next</h3>
        <section>
            <div>
                <h1 className='light_text'>{String(minutes).padStart(2, '0')}</h1>
                <h5>Minutes</h5>
            </div>
            <div>
                <h1 className='light_text'>{String(seconds).padStart(2, '0')}</h1>
                <h5>Seconds</h5>
            </div>
        </section>
        <p>To Unlock Bonuses Worth <span>Rs 6,487</span>​</p>
    </div>
</div>

<hr className='breakline'/>

{/* business */}

<div className="business sec">
    <h1>What Will Change In Your Business?</h1>
    <img src={require('../Assets/circle.png')} />
    <button onClick={buttonClick} class="register_btn">REGISTER NOW AT ₹99/- ONLY</button>

</div>

{/* workshop */}

<div className="workshop">
<h1>What Will Change In Your Business?</h1>
<img src={require('../Assets/Dont-join 1.png')} />
</div>


{/* learn */}

<div className="learn sec">
<h1>What You Will Learn In 3 Hrs<br/>
(2.5 Hrs + 30 Mins Bonus Content)?</h1>

<section>

<div className="left_section">
    <img src={require('../Assets/standing.png')}/>
</div>
<div className="right_section">

<div>
    <span>01.</span> <h5>How To Build A Growth Business Rather Than A Survival Business.    </h5>
</div>

<div>
    <span>02.</span> <h5>Characteristics Of Growth And Survival Businesses  </h5>
</div>


<div>
    <span>03.</span> <h5>3 Reasons Why Business Owners Get Stuck In Survival.    </h5>
</div>


<div>
    <span>04.</span> <h5>Focus Areas To Build A Growth Business.

Strategies Are Applicable To ALL Types Of Businesses, Regardless Of Industry Or Team Size  </h5>
</div>




</div>

</section>

</div>

{/* today price */}

<div className="today_price">

<section>
    <p>Total Value : <s>₹7,486/</s></p>
    <h4>Regular Price :₹999/</h4>
    <h2>Today's Price :₹99/-</h2>
    <button onClick={buttonClick} class="register_btn">REGISTER NOW AT ₹99/- ONLY</button>
    <p>Reserve Your Seat Before The Timer Ends To Unlock To End Bonuses Worth 6,487/-</p>
    <section>
            <div>
                <h1 className='light_text'>{String(minutes).padStart(2, '0')}</h1>
                <h5>Minutes</h5>
            </div>
            <div>
                <h1 className='light_text'>{String(seconds).padStart(2, '0')}</h1>
                <h5>Seconds</h5>
            </div>
        </section>
</section>

</div>


{/* meet */}
<div className="meet">
    <h1>Meet Your Coach</h1>
    <div className="profile">
        <div className="image">
            <img src={require('../Assets/Rajesh Gurusamy profile circle.png')} width="100%" />
        </div>
        <div className="detail">
            <h1>Dr Rajesh Gurusamy</h1>
            <p>India’s Leading Business Success Coach</p>
        </div>
    </div>

<div className="_badges">

<div className="_badge">
    <div className="top">
        <h1>16</h1>
        <img src={require('../Assets/ic1.png')} ></img>
    </div>
    <p>Years of Experience in Training and Coaching</p>
</div>

<div className="_badge">
    <div className="top">
        <h1>50M</h1>
        <img src={require('../Assets/ic2.png')} ></img>
    </div>
    <p>Entrepreneurs Reached In The Last 6 Years</p>
</div>

<div className="_badge">
    <div className="top">
        <h1>500+</h1>
        <img src={require('../Assets/ic3.png')} ></img>
    </div>
    <p>Seminars And Workshops Conducted In The Last 6 Years</p>
</div>

<div className="_badge">
    <div className="top">
        <h1>500k</h1>
        <img src={require('../Assets/ic4.png')} ></img>
    </div>
    <p>Social Media
Following</p>
</div>

<div className="_badge">
    <div className="top">
        <h1>100k</h1>
        <img src={require('../Assets/ic5.png')} ></img>
    </div>
    <p>Paid
Customers</p>
</div>

<div className="_badge">
    <div className="top">
        <h1>18k</h1>
        <img src={require('../Assets/ic6.png')} ></img>
    </div>
    <p>Live Entrepreneurs
Community</p>
</div>

<div className="_badge">
    <div className="top">
        <h1>2000+</h1>
        <img src={require('../Assets/ic7.png')} ></img>
    </div>
    <p>Coaching
Clients</p>
</div>

<div className="_badge">
    <div className="top">
        <h1>190+</h1>
        <img src={require('../Assets/ic8.png')} ></img>
    </div>
    <p>Industries
Worked With</p>
</div>

<div className="_badge">
    <div className="top">
        <h1>30+</h1>
        <img src={require('../Assets/ic1.png')} ></img>
    </div>
    <p>In-House
Business Coaches</p>
</div>

<div className="_badge">
    <div className="top">
        <h1>5</h1>
        <img src={require('../Assets/ic9.png')} ></img>
    </div>
    <p>Trained In More
Than Five Countries</p>
</div>

</div>


</div>

{/* promise */}

<div className="promise">
    <h1 className='light_text'>Still Not Sure? We got your Back!</h1>
    <section>
        <div className="left_section">
            <img src={require('../Assets/money back.webp')} width="100%" />
        </div>
        <div className="right_section">
            <h3>Our Guarantee</h3>
            <p>Get this amazing offer today for just Rs 99, and get a money – back guarantee. Join today, go through our seminar and if you don’t like it for any reason, simply send us an email and we’ll refund every penny – no questions asked!</p>
            <button onClick={buttonClick} class="register_btn">REGISTER NOW AT ₹99/- ONLY</button>
        </div>
    </section>

<div className="sign_banner">
    <h1>A Promise</h1>
    <p className='bold_text'>No Questions Asked Money Back Guarantee</p>
    <p>Dear Sir / Ma’am,</p>
    <p>I am here to help you grow your business, and I am here to share extremely valuable secrets and insights which have impacted 50 Million+ people overall, and I personally ensure everyone who comes and attends my workshops gets more than they expected.<br/><br/>
    If after attending the workshop, you still don’t find enough value for some reason, I take complete responsibility and ownership of that and hence, I promise to give a complete refund of the workshop amount of Rs 99. All you have to do is mail to me at rajeshgursamy@gmail.com and my team will ensure you are provided with a refund in the shortest amount of time.</p>
<div className="sign">
    <p>Your's</p> <img src={require('../Assets/sign.png')} />
</div>
</div>

</div>


{/* faq */}
<div className="faq">
    <h1>Frequently Asked Questions</h1>

    <div class="accordion accordion-flush" id="accordionFlushExample">
  <div class="accordion-item">
    <h2 class="accordion-header">
      <button class="accordion-button collapsed" type="button" data-bs-toggle="collapse" data-bs-target="#flush-collapseOne" aria-expanded="false" aria-controls="flush-collapseOne">
      How I’ll get the link to attend the program?
      </button>
    </h2>
    <div id="flush-collapseOne" class="accordion-collapse collapse" data-bs-parent="#accordionFlushExample">
      <div class="accordion-body">You will get an email right after you register. Do check the spam and promotions tab just in case it landed there.</div>
    </div>
  </div>
  <div class="accordion-item">
    <h2 class="accordion-header">
      <button class="accordion-button collapsed" type="button" data-bs-toggle="collapse" data-bs-target="#flush-collapseTwo" aria-expanded="false" aria-controls="flush-collapseTwo">
      How I’ll get the bonus items?
      </button>
    </h2>
    <div id="flush-collapseTwo" class="accordion-collapse collapse" data-bs-parent="#accordionFlushExample">
      <div class="accordion-body">Bonus 1 and 4, you will get it right after you sign up for the program.

Bonus 2, you will get it only if you attend and finish the seminar.

Bonus 4: Live, at the end of the seminar.</div>
    </div>
  </div>
  <div class="accordion-item">
    <h2 class="accordion-header">
      <button class="accordion-button collapsed" type="button" data-bs-toggle="collapse" data-bs-target="#flush-collapseThree" aria-expanded="false" aria-controls="flush-collapseThree">
      Why does this program cost only ₹99?
      </button>
    </h2>
    <div id="flush-collapseThree" class="accordion-collapse collapse" data-bs-parent="#accordionFlushExample">
      <div class="accordion-body">The fee is just to make sure to get a commitment from you that you will be there. It is not the value of the program. Attend the program and understand the value yourself.</div>
    </div>
  </div>

  <div class="accordion-item">
    <h2 class="accordion-header">
      <button class="accordion-button collapsed" type="button" data-bs-toggle="collapse" data-bs-target="#flush-collapseFour" aria-expanded="false" aria-controls="flush-collapseFour">
      Will I get the recording of the program?
      </button>
    </h2>
    <div id="flush-collapseFour" class="accordion-collapse collapse" data-bs-parent="#accordionFlushExample">
      <div class="accordion-body">This is a live program where Rajiv will be training. So no recording will be provided.</div>
    </div>
  </div>

  <div class="accordion-item">
    <h2 class="accordion-header">
      <button class="accordion-button collapsed" type="button" data-bs-toggle="collapse" data-bs-target="#flush-collapseFive" aria-expanded="false" aria-controls="flush-collapseFive">
      Why is the training during business hours?
      </button>
    </h2>
    <div id="flush-collapseFive" class="accordion-collapse collapse" data-bs-parent="#accordionFlushExample">
      <div class="accordion-body">This is an investment in your business when you learn you grow. I strongly believe that every entrepreneur has a personal life and would want to make sure you are learning during your business hours as you implement what you learn here in your business.</div>
    </div>
  </div>

  <div class="accordion-item">
    <h2 class="accordion-header">
      <button class="accordion-button collapsed" type="button" data-bs-toggle="collapse" data-bs-target="#flush-collapseSix" aria-expanded="false" aria-controls="flush-collapseSix">
      Who is this seminar ideal for?
      </button>
    </h2>
    <div id="flush-collapseSix" class="accordion-collapse collapse" data-bs-parent="#accordionFlushExample">
      <div class="accordion-body">Entrepreneurs and entrepreneurs only. If you have an existing business with products/services or a team and don’t know what is your next step in business then this is for you.</div>
    </div>
  </div>
  
  <div class="accordion-item">
    <h2 class="accordion-header">
      <button class="accordion-button collapsed" type="button" data-bs-toggle="collapse" data-bs-target="#flush-collapseSeven" aria-expanded="false" aria-controls="flush-collapseSeven">
      Is this applicable to my industry?
      </button>
    </h2>
    <div id="flush-collapseSeven" class="accordion-collapse collapse" data-bs-parent="#accordionFlushExample">
      <div class="accordion-body">People from more than 190 industries have attended this webinar and 99.3% of them have said this is applicable for their business. So, yes. It is applicable no matter which industry you are in. Attend and find that out</div>
    </div>
  </div>

  <div class="accordion-item">
    <h2 class="accordion-header">
      <button class="accordion-button collapsed" type="button" data-bs-toggle="collapse" data-bs-target="#flush-collapseEight" aria-expanded="false" aria-controls="flush-collapseEight">
      Can I attend this if I want to start a business but don't have one yet?
      </button>
    </h2>
    <div id="flush-collapseEight" class="accordion-collapse collapse" data-bs-parent="#accordionFlushExample">
      <div class="accordion-body">No, attend only after you have an existing business.</div>
    </div>
  </div>


  <div class="accordion-item">
    <h2 class="accordion-header">
      <button class="accordion-button collapsed" type="button" data-bs-toggle="collapse" data-bs-target="#flush-collapseNine" aria-expanded="false" aria-controls="flush-collapseNine">
      What if I have questions about registration, attending, etc?
      </button>
    </h2>
    <div id="flush-collapseNine" class="accordion-collapse collapse" data-bs-parent="#accordionFlushExample">
      <div class="accordion-body">You can drop us a DM on Instagram. We will be happy to help you.</div>
    </div>
  </div>

  <div class="accordion-item">
    <h2 class="accordion-header">
      <button class="accordion-button collapsed" type="button" data-bs-toggle="collapse" data-bs-target="#flush-collapseTen" aria-expanded="false" aria-controls="flush-collapseTen">
      If I miss attending this time can I attend this again?
      </button>
    </h2>
    <div id="flush-collapseTen" class="accordion-collapse collapse" data-bs-parent="#accordionFlushExample">
      <div class="accordion-body">Yes you may attend it again at a later date</div>
    </div>
  </div>

  <div class="accordion-item">
    <h2 class="accordion-header">
      <button class="accordion-button collapsed" type="button" data-bs-toggle="collapse" data-bs-target="#flush-collapseEleven" aria-expanded="false" aria-controls="flush-collapseEleven">
      What do I need to keep handy during the webinar?      </button>
    </h2>
    <div id="flush-collapseEleven" class="accordion-collapse collapse" data-bs-parent="#accordionFlushExample">
      <div class="accordion-body">Just an open mind and a book to make a lot of notes.</div>
    </div>
  </div>

  <div class="accordion-item">
    <h2 class="accordion-header">
      <button class="accordion-button collapsed" type="button" data-bs-toggle="collapse" data-bs-target="#flush-collapseTwelve" aria-expanded="false" aria-controls="flush-collapseTwelve">
      Can I attend this program along with my business partner(s)?
          </button>
    </h2>
    <div id="flush-collapseTwelve" class="accordion-collapse collapse" data-bs-parent="#accordionFlushExample">
      <div class="accordion-body">Yes you can, it is preferred you attend with your partners so that you can learn together.</div>
    </div>
  </div>

</div>


</div>







<div className="bottom_btn">
<button onClick={buttonClick} class="register_btn">REGISTER NOW AT ₹99/- ONLY</button>
</div>




{enquire &&
<div className="enquiry">
  <div className="overlay" onClick={()=>setEnquire(false)}></div>
  <form onSubmit={(e)=>submitForm(e)}>
            <h1>Enquiry Us !</h1>
            <div>
                <input type='text' value={name} placeholder='Enter Name' onChange={(e)=>setName(e.target.value)}/>
                    <input type='number' value={number} placeholder='Enter Mobile Number' onChange={(e)=>setNumber(e.target.value)}/>
                <input type='email' value={email} placeholder='Enter Mail ID' onChange={(e)=>setEmail(e.target.value)}/>
             
             {err &&  <p className='err'>Please fill all the fields</p> }
                <button type='submit' className='register_btn'>Enquire Now</button>
            </div>
        </form></div>

}







<div className="base_sticky">
    <div className="left">
        <div className="price">
            <h1>₹99</h1> <s>₹999</s>
        </div>
        <h4>Offer Ends in 15 Mins</h4>
    </div>
    <button onClick={buttonClick} class="register_btn">REGISTER NOW AT ₹99/- ONLY</button>

</div>
    </div>
  )
}
